// Vendor imports
const classNames = require('classnames')
const _ = require('lodash')
const React = require('react')
const ReactRedux = require('react-redux')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const AddToCollectionModal = require('client-v2/common/containers/lightweight-engagement/containers/add-to-collection-modal/components/modal-smart')
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const contentAddModalActions = require('../actions')

const bem = BemEntity('ContentAddModalUrlSubmitted')

function ContentAddModalUrlSubmitted({ className }) {
  const dispatch = ReactRedux.useDispatch()
  const onUnmixPromptConfirm = React.useCallback(
    () => dispatch(contentAddModalActions.confirmUnmix()),
    [ dispatch ]
  )
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('header-toast')
      },
        'Added to your profile!'
      ),
      tag(AddToCollectionModal, {
        // Override mapDispatchToProps
        onDismiss: _.noop,
        onUnmixPromptConfirm
      })
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  ContentAddModalUrlSubmitted.propTypes = {
    // Values
    className: PropTypes.string
  }
}

module.exports = ContentAddModalUrlSubmitted
